function getCountLabel(action, count) {
  return `${action} (${count}) selected card${count === 1 ? "" : "s"}`;
}

function getRemoveTradebinderLabel(count) {
  return `Remove (${count}) card${count === 1 ? "" : "s"} from tradebinder`;
}

function getUpdatePricesLabel(count) {
  return `Update prices on (${count}) selected card${count === 1 ? "" : "s"}`;
}

export default function SelectionActions({
  selectedCards,
  activeSelectionGroup,
  hasSelectedUnlistedCards,
  hasSelectedStacks,
  hasSelectedListedCards,
  hasSelectedLockedListedCards,
  selectedUnlistedCount,
  selectedListedCount,
  selectedLockedListedCount,
  onList,
  onUpdatePrices,
  onSplit,
  onDelist,
  onRemove,
}) {
  if (selectedCards.length === 0) {
    return null;
  }

  const isUnlistedSelection = activeSelectionGroup === "unlisted";
  const isListedSelection = activeSelectionGroup === "listed";
  const areListedActionsBlocked = isListedSelection && hasSelectedLockedListedCards;

  return (
    <div
      style={{
        position: "fixed",
        right: "24px",
        bottom: "76px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        zIndex: 1001
      }}
    >
      <button
        className="app-button-base"
        style={{
          background: isListedSelection
            ? ((hasSelectedListedCards && !areListedActionsBlocked) ? "#1976d2" : "#90caf9")
            : (hasSelectedUnlistedCards ? "#1976d2" : "#90caf9"),
          color: "white",
          border: "none",
          borderRadius: "10px",
          cursor: isListedSelection
            ? ((hasSelectedListedCards && !areListedActionsBlocked) ? "pointer" : "not-allowed")
            : (hasSelectedUnlistedCards ? "pointer" : "not-allowed"),
          boxShadow: isListedSelection
            ? ((hasSelectedListedCards && !areListedActionsBlocked) ? "0 10px 24px rgba(25,118,210,0.28)" : "none")
            : (hasSelectedUnlistedCards ? "0 10px 24px rgba(25,118,210,0.28)" : "none")
        }}
        onClick={isListedSelection ? onUpdatePrices : onList}
        disabled={isListedSelection ? (!hasSelectedListedCards || areListedActionsBlocked) : !hasSelectedUnlistedCards}
      >
        {isListedSelection
          ? (areListedActionsBlocked ? `${selectedLockedListedCount} locked card${selectedLockedListedCount === 1 ? "" : "s"} selected` : getUpdatePricesLabel(selectedListedCount))
          : getCountLabel("List", selectedUnlistedCount)}
      </button>
      <button
        className="app-button-base"
        style={{
          background: hasSelectedStacks ? "#455a64" : "#b0bec5",
          color: "white",
          border: "none",
          borderRadius: "10px",
          cursor: hasSelectedStacks ? "pointer" : "not-allowed",
          boxShadow: hasSelectedStacks ? "0 10px 24px rgba(69,90,100,0.28)" : "none"
        }}
        onClick={onSplit}
        disabled={!hasSelectedStacks}
      >
        Split selected cards
      </button>
      <button
        className="app-button-base"
        style={{
          background: isUnlistedSelection
            ? (hasSelectedUnlistedCards ? "#c62828" : "#ef9a9a")
            : ((hasSelectedListedCards && !areListedActionsBlocked) ? "#c62828" : "#ef9a9a"),
          color: "white",
          border: "none",
          borderRadius: "10px",
          cursor: isUnlistedSelection
            ? (hasSelectedUnlistedCards ? "pointer" : "not-allowed")
            : ((hasSelectedListedCards && !areListedActionsBlocked) ? "pointer" : "not-allowed"),
          boxShadow: isUnlistedSelection
            ? (hasSelectedUnlistedCards ? "0 10px 24px rgba(198,40,40,0.28)" : "none")
            : ((hasSelectedListedCards && !areListedActionsBlocked) ? "0 10px 24px rgba(198,40,40,0.28)" : "none")
        }}
        onClick={isUnlistedSelection ? onRemove : onDelist}
        disabled={isUnlistedSelection ? !hasSelectedUnlistedCards : (!hasSelectedListedCards || areListedActionsBlocked)}
      >
        {isUnlistedSelection
          ? getRemoveTradebinderLabel(selectedUnlistedCount)
          : (areListedActionsBlocked ? `${selectedLockedListedCount} locked card${selectedLockedListedCount === 1 ? "" : "s"} selected` : getCountLabel("Delist", selectedListedCount))}
      </button>
    </div>
  );
}